export enum UnitType {
    SI = 'SI',
    IMPERIAL = 'IMPERIAL',
}